module.exports = __webpack_public_path__ + "static/media/NICE_Step3a_Image2.ac9a4178.jpg";